// Proton's public-page frame (account/public Layout): radial page background,
// the Layer7 lockup top-left, centred content, a hint footer. Shared by the
// pages that live outside Shell: sign-in, booking, RSVP and meeting links.
import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import clsx from "clsx";
import { Icon } from "./Icon";

export function PublicLayout({ footer, children }: { footer?: ReactNode; children: ReactNode }) {
  return (
    <div className="fixed inset-0 overflow-y-auto welcome-bg sign-layout-page">
      <header className="sign-layout-top">
        <img src="/brand/logo-horizontal.svg" alt="Layer7" className="h-7 w-auto" draggable={false} />
      </header>
      <main className="sign-layout-container">{children}</main>
      {footer && <footer className="sign-layout-footer">{footer}</footer>}
    </div>
  );
}

export function PublicStatusIcon({
  icon, tone = "weak",
}: {
  icon: LucideIcon;
  tone?: "weak" | "success" | "primary" | "danger";
}) {
  return (
    <span className={clsx("public-status-icon", tone !== "weak" && `public-status-icon--${tone}`)}>
      <Icon as={icon} size={6} />
    </span>
  );
}

export function PublicSpinner({ label }: { label?: string }) {
  return (
    <div className="flex flex-col items-center gap-3 color-weak" role="status">
      <span className="circle-loader public-spinner color-primary" aria-hidden="true" />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}

// One row of a .public-details-list <dl>: glyph, weak label, value.
export function DetailRow({ icon, label, value }: { icon: LucideIcon; label: string; value: ReactNode }) {
  return (
    <div className="flex gap-3">
      <Icon as={icon} className="mt-0.5 color-weak" />
      <div className="min-w-0">
        <dt className="text-sm color-weak">{label}</dt>
        <dd className="m-0 break-words">{value}</dd>
      </div>
    </div>
  );
}
